import { TypedUseSelectorHook, useDispatch } from "react-redux";
import type { IRootState, IAppDispatch } from "./store";
import { useSelector } from "react-redux";

export const useAppDispatch: () => IAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector;

export const useReduxStore = <K extends keyof IRootState>(
  key: K,
): IRootState[K] => useAppSelector((state) => state[key]);
